/*
Copyright (c) 2011, Daniel Guerrero
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:
    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the
      documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL DANIEL GUERRERO BE LIABLE FOR ANY
DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Uses the new array typed in javascript to binary base64 encode/decode
 * at the moment just decodes a binary base64 encoded
 * into either an ArrayBuffer (decodeArrayBuffer)
 * or into an Uint8Array (decode)
 *
 * References:
 * https://developer.mozilla.org/en/JavaScript_typed_arrays/ArrayBuffer
 * https://developer.mozilla.org/en/JavaScript_typed_arrays/Uint8Array
 */
var Base64Binary = {
	_keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

	/* will return a  Uint8Array type */
	decodeArrayBuffer: function(input) {
		var bytes = (input.length/4) * 3;
		var ab = new ArrayBuffer(bytes);
		this.decode(input, ab);

		return ab;
	},

	removePaddingChars: function(input) {
		var lkey = this._keyStr.indexOf(input.charAt(input.length - 1));
		if (lkey == 64){
			return input.substring(0,input.length - 1);
		}
		return input;
	},

	decode: function(input, arrayBuffer) {
		//get last chars to see if are valid
		input = this.removePaddingChars(input);
		input = this.removePaddingChars(input);

		var bytes = parseInt((input.length / 4) * 3, 10);

		var uarray;
		var chr1, chr2, chr3;
		var enc1, enc2, enc3, enc4;
		var i = 0;
		var j = 0;

		if (arrayBuffer)
			uarray = new Uint8Array(arrayBuffer);
		else
			uarray = new Uint8Array(bytes);

		input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

		for (i=0; i<bytes; i+=3) {
			//get the 3 octects in 4 ascii chars
			enc1 = this._keyStr.indexOf(input.charAt(j++));
			enc2 = this._keyStr.indexOf(input.charAt(j++));
			enc3 = this._keyStr.indexOf(input.charAt(j++));
			enc4 = this._keyStr.indexOf(input.charAt(j++));

			chr1 = (enc1 << 2) | (enc2 >> 4);
			chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
			chr3 = ((enc3 & 3) << 6) | enc4;

			uarray[i] = chr1;
			if (enc3 != 64) uarray[i+1] = chr2;
			if (enc4 != 64) uarray[i+2] = chr3;
		}

		return uarray;
	}
};

(function() {
    'use strict';
    function transitionDuration(el) {
        let duration = getComputedStyle(el).transitionDuration;
        if (duration == "") {
            return 0;
        } else if (duration.endsWith('ms')) {
            return parseFloat(duration.substring(0, duration.length - 2));
        } else if (duration.endsWith('s')) {
            return parseFloat(duration.substring(0, duration.length - 1)) * 1000;
        } else {
            return 0;
        }

    }
    window.$lib = {
        hide: function(el) {
            let noTransition = el.classList.contains('notransition');
            if (!noTransition) {
                el.classList.add('notransition');
            }
            el.style.display = 'none';
            el.classList.add('is-hidden');
            if (!noTransition) {
                el.classList.remove('notransition');
            }
        },
        show: function(el) {
            let noTransition = el.classList.contains('notransition');
            if (!noTransition) {
                el.classList.add('notransition');
            }
            el.style.display = '';
            el.classList.remove('is-hidden');
            if (!noTransition) {
                el.classList.remove('notransition');
            }
        },
        ready: function(fn) {
            if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
              fn();
            } else {
              document.addEventListener('DOMContentLoaded', fn);
            }
        },
        slideDown: function(el, callback) {
            let maxHeight = el.style.maxHeight;
            let ms = el.classList.contains('is-hidden') ? transitionDuration(el) : 0;
            el.style.display = '';
            el.style.maxHeight = $lib.height(el) + 'px';
            void(el.offsetHeight);
            el.classList.remove('is-hidden');
            window.setTimeout(() => {
                el.style.maxHeight = maxHeight;
                if (typeof callback === 'function') {
                    callback();
                }
            }, ms)
        },
        slideUp: function(el, callback) {
            let maxHeight = el.style.maxHeight;
            let ms = el.classList.contains('is-hidden') ? 0 : transitionDuration(el);
            el.style.maxHeight = $lib.height(el) + 'px';
            void(el.offsetHeight);
            el.classList.add('is-hidden');
            window.setTimeout(() => {
                el.style.display = 'none';
                el.style.maxHeight = maxHeight;
                if (typeof callback === 'function') {
                    callback();
                }
            }, ms)
        },
        parent: function(el, selector) {
            let parentItem = el.parentElement;
            while (parentItem != null && !parentItem.matches(selector)) {
                parentItem = parentItem.parentElement;
            }
            return parentItem;
        },
        height: function(el) {
            let previousStyle = el.style.cssText;
            el.style.cssText += "max-height: none !important; position: absolute; visibility: hidden; display: block;";
            let height = el.offsetHeight;
            el.style.cssText = previousStyle;
            return height;
        },
        createElementFromHTML: function(html) {
            let template = document.createElement('template')
            template.innerHTML = html.trim();
            return template.content.firstChild;
        }
    };
})();

window.addEventListener('load', () => {
    'use strict';

    let handles = document.querySelectorAll(".collapse-handle");

    let collapseResizeHandles = [];

    function isMobile() {
        return window.getComputedStyle(document.body, '::after').content == '"mobile"';
    }

    function handleMobile(handle, item, m) {
        if (handle.dataset.collapsedUsed === true) {
            return;
        }

        let mobile = m === undefined ? isMobile() : m;
        let collapsed = handle.classList.contains('collapsed');

        if ((mobile && !collapsed) || (!mobile && collapsed)) {
            handle.classList.add('notransition');
            if (collapsed) {
                $lib.show(item);
            } else {
                $lib.hide(item);
            }
            handle.classList.toggle('collapsed');
            void(handle.offsetHeight);
            handle.classList.remove('notransition');
        }
    }

    handles.forEach(handle => {
        let item = document.getElementById(handle.dataset.collapseItem);

        if (handle.classList.contains('collapse-on-mobile')) {
            collapseResizeHandles.push([handle, item]);
            handleMobile(handle, item);
        }

        handle.classList.add('active');
        item.classList.add('toggle');

        handle.addEventListener('click', () => {
            handle.classList.toggle('collapsed');
            handle.dataset.collapsedUsed = true;
            if (item.classList.contains('is-hidden')) {
                $lib.slideDown(item);
            } else {
                $lib.slideUp(item);
            }
        });
    });

    let mobile = isMobile();
    window.addEventListener('resize', () => {
        let m = isMobile();
        if (m == mobile) {
            return;
        }
        mobile = m;
        collapseResizeHandles.forEach(el => {
            handleMobile(el[0], el[1], mobile);
        });
    });

    document.querySelectorAll('a[data-track]').forEach(a => {
        if (a.hostname == window.location.hostname) {
            return;
        }
        let track = a.dataset.track;
        if (track.length == 0) {
            return;
        }
        if (track[0] != '/') {
            track = '/' + track;
        }
        a.addEventListener('click', () => {
            navigator.sendBeacon('/track' + track);
        }, {passive: true});
    });
});

$lib.ready(() => {
    'use strict';
    const KEY = Base64Binary.decode("/qgL0FEnR0tiCrzyLoP83Sm9oAVuENRtQMkhDpbKe+w=");
    // Decode E-Mails
    document.querySelectorAll(".mdr-obfs").forEach(mdr => {
        let encMail = Base64Binary.decode(mdr.dataset.em);
        let decMail = [...encMail].map((ch, i) =>
            String.fromCharCode((256 + ch - KEY[i % KEY.length]) % 256)
        ).join("");

        var link = document.createElement("a");
        link.href = "mailto:" + encodeURIComponent(decMail);
        link.innerText = decMail;
        link.classList.add("unobtrusive");
        mdr.replaceWith(link);
    });

    // Top menu, register click to show submenus when clicking on parent
    document.querySelectorAll("a label.drop-icon").forEach(label => {
        let button = $lib.parent(label, ".button");
        let checkbox = $lib.parent(label, "li").querySelector('input[type="checkbox"]');
        button.addEventListener('click', event => {
            event.preventDefault();
            checkbox.checked = !checkbox.checked;
        });
    });

    // Increase click area to full <li> (in mobile view)
    document.querySelectorAll(".side-menu-list li").forEach(li => {
        let a = li.querySelector("a");
        if (a !== null) {
            li.style.cursor = 'pointer';
            li.addEventListener('click', event => {
                a.click();
            });
        }
    });

    // File uploads
    document.querySelectorAll('input[type="file"]').forEach(input => {
      let label = document.querySelector(`label.fileinput[for="${input.id}"]`)
      if (label === null) {
        return;
      }
      let labelText = label.querySelector('.text');
      let labelOriginalHTML = labelText.innerHTML;
      if (input.files.length == 1) {
        labelText.innerHTML = input.files[0].name;
      } else if (input.dataset.tokenField) {
        let tokenField = document.getElementById(input.dataset.tokenField);
        if (tokenField !== null && tokenField.dataset.name) {
          labelText.innerHTML = tokenField.dataset.name;
          input.removeAttribute('required');
        }
      }
      input.addEventListener('change', e => {
          let fileName = e.target.value.split( '\\' ).pop();
          if (fileName) {
            labelText.innerHTML = fileName;
          }
          else {
            labelText.innerHTML = labelOriginalHTML;
          }
        });
    });
});
